<template>
  <section>
    <div class="tip" style="margin: 25px 0 0 20px">* 项目基本资料</div>
    <ul class="project-info-list">
      <li>
        <label>项目名称：</label>
        <div class="info-item">{{ form.name }}</div>
      </li>
      <li>
        <label>项目编号：</label>
        <div class="info-item">{{ form.number }}</div>
      </li>
      <li v-if="form.wxType != 'A' && form.wxType != 'B'">
        <label>实施类别：</label>
        <div class="info-item">{{ form.sslb }}</div>
      </li>
      <li>
        <label>项目需求单位：</label>
        <div class="info-item">{{ project.deptName }}</div>
      </li>
      <li v-if="project.type != 4">
        <label>项目负责人：</label>
        <div class="info-item">{{ project.leader.name }}</div>
      </li>
      <li v-else>
        <label>项目申报人：</label>
        <div class="info-item">{{ project.leader.name }}</div>
      </li>
      <li>
        <label>联系方式：</label>
        <div class="info-item">{{ project.leader.mobile }}</div>
      </li>

      <li>
        <label>项目组：</label>
        <div class="info-item">
          {{ form.project.team ? form.project.team.name : "" }}
        </div>
      </li>
      <li>
        <label>是否子项目：</label>
        <div class="info-item">
          {{
            form.level == 0
              ? "父级项目"
              : form.project.father
              ? '项目"' + form.project.father.name + '"的子项目'
              : "子项目"
          }}
        </div>
      </li>
      <li v-if="form.type != 3 && form.type != 4">
        <label>是否需要招标：</label>
        <div class="info-item">{{ form.iszb == 0 ? "否" : "是" }}</div>
      </li>

      <li class="block intro-box" v-if="form.type != 3">
        <label>项目介绍：</label>
        <div class="info-item">{{ form.intro }}</div>
      </li>
      <li class="block intro-box" v-else>
        <label>需求情况介绍：</label>
        <div class="info-item">{{ form.intro }}</div>
      </li>
    </ul>

    <div v-if="form.type == 4 || form.type == 5">
      <div class="tip" style="margin: 20px 0 0 30px">* 资金安排</div>
      <ul class="project-info-list">
        <li>
          <label>项目估算金额(元)：</label>
          <div class="info-item">{{ form.xmgs?(isNaN(form.xmgs)?"/":form.xmgs):"/" }}</div>
        </li>
        <li>
          <label>项目工期(天)：</label>
          <div class="info-item">{{ form.xmgq?(isNaN(form.xmgq)?"/":form.xmgq):"/" }}</div>
        </li>
      </ul>
    </div>

    <div v-if="form.type != 2 && form.type != 3 && form.type != 4">
      <div class="tip" style="margin: 20px 0 0 30px">* 资金安排</div>
      <ul class="project-info-list">
        <li>
          <label>估算投资(元)：</label>
          <div class="info-item">{{ form.xmgs }}</div>
        </li>
        <li>
          <label>总工期(天)：</label>
          <div class="info-item">{{ form.xmgq }}</div>
        </li>
        <li>
          <label>资金来源：</label>
          <div class="info-item">{{ form.zjly }}</div>
        </li>
      </ul>

      <div class="tip" style="margin: 20px 0 0 30px">* 前期工作及施工要求</div>
      <ul class="project-info-list">
        <li class="label-li">
          <label>是否需要委托设计：</label>
          <div class="info-item">
            {{ form.iswtsj ? "是" : "否" }}
          </div>
        </li>
        <li class="label-li">
          <div v-if="form.iswtsj">
            <label>设计单位发包方式：</label>
            <div class="info-item">
              {{ form.sjdwfbfs ? form.sjdwfbfs : "未填" }}
            </div>
          </div>
        </li>

        <li class="label-li">
          <label>初步设计计划评审时间：</label>
          <div class="info-item">{{ getYtime(form.jhpssj) }}</div>
        </li>
        <li class="label-li">
          <label>计划概算批复时间：</label>
          <div class="info-item">{{ getYtime(form.jhgspfsj) }}</div>
        </li>
        <li class="label-li">
          <label>计划招标控制价备案时间：</label>
          <div class="info-item">{{ getYtime(form.zbbasj) }}</div>
        </li>
        <li class="label-li">
          <label>计划施工招标完成时间：</label>
          <div class="info-item">{{ getYtime(form.sgzbwcsj) }}</div>
        </li>
        <li class="label-li">
          <label>计划材料完成招标时间：</label>
          <div class="info-item">{{ getYtime(form.clwczbsj) }}</div>
        </li>
        <li class="label-li">
          <label>计划设备完成招标时间：</label>
          <div class="info-item">{{ getYtime(form.sbwczbsj) }}</div>
        </li>
        <li class="label-li">
          <label>计划开工时间：</label>
          <div class="info-item">{{ getYtime(form.jhkgsj) }}</div>
        </li>
        <li class="label-li">
          <label>计划完工时间：</label>
          <div class="info-item">{{ getYtime(form.jhwgsj) }}</div>
        </li>
      </ul>
    </div>
  </section>
</template>
<script>
  export default {
    props: [
      "form",
      "userData",
      "project",
      "teamArr",
      "projectArr",
      "operationType",
    ],
    data() {
      return {
        // form: {}
      };
    },
    mounted() {
      // this.form = this.formByFather
    },
    methods: {
      getYtime(t) {
        switch (t) {
          case "-1":
            return "已完成";
            break;
          case "-2":
            return "无";
            break;
          default:
            return t ? t : "未填";
            break;
        }
      },
    },
  };

</script>



// WEBPACK FOOTER //
// src/page/user/projectinfo/create.vue